<template>
  <div class="goldlocker">
    <Header />
    <div class="container">
      <div class="banner-ad">
        <ads-91 :unitIdentifier="BannerIdentifier" />
      </div>
      <div class="middle-panel">
        <div class="gold-item">
          <GoldDetails :goldPrice="gold.current_price" />
        </div>
        <div class="gold-item gold-content">
          <UserGoldDetail />
        </div>
      </div>
      
      <div class="amount-text amount-li">
        <ul>
          <li tag="li" @click="redirectTo('/buy-gold')">
            {{ $t("buy") }}
             <img src="../assets/images/ic_right.svg" />
          </li>
          <li tag="li" @click="redirectTo('/sell-gold')">
            {{ $t("sell") }}
             <img src="../assets/images/ic_right.svg" />
           </li>
        </ul>
      </div>
      <div class="scroll-content">
      <Transaction />
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img
        src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import Transaction from "../components/Transaction";
import GoldDetails from "../components/GoldDetails";
import UserGoldDetail from "../components/UserGoldDetail";
import types from "../store/types";
import { toaster } from "../utils/helper";
import { SessionHelper, LANG } from "../utils/session";

export default {
  name: "Goldlocker",
  components: {
    Header,
    GoldDetails,
    UserGoldDetail,
    Transaction
  },

  data() {
    return {
      loading: false,
      BannerIdentifier: "1a2cc0fe-cc7b-46ad-acab-2c4ff73f1d17",
    };
  },

  computed: {
    ...mapGetters(["user", "gold", "isUserAuthorized"])
  },

  methods: {
    redirectTo(type) {
      if (!this.isUserAuthorized) {
        toaster(this, this.$t("notauthorised"), "top-left", 1000);
        return;
      }
      const { is_registered, user_purse_details } = this.user;
      if (!is_registered) {
        toaster(this, this.$t("notregistered"), "top-left", 2000);
        this.$router.push("/registration");
        return;
      }
      if (type === "/sell-gold" && !this.user.total_gold_amount) {
        toaster(this, this.$t("enoughgoldtosell"), "top-left", 2000);
        return;
      }
      if (!user_purse_details.mcash) {
        toaster(this, this.$t("nompoint_sellandbuy"), "top-left", 2000);
        return;
      }
      this.$router.push(type);
    },

    changeLocale() {
      if (["tl", "ta"].includes(SessionHelper.getCookie(LANG))) {
        document.querySelector("body").classList.add("activeMultiLang");
      }
      this.$i18n.locale =
        SessionHelper.getCookie(LANG) || document.URL.split("=")[1] || "hi";
    },

    getLatestGoldPrice() {
      this.loading = !this.loading;
      this.$store
        .dispatch({ type: "buyPrice" })
        .then(data => {
          this.loading = !this.loading;

          this.$store.commit(types.BUYPRICE, data.data.data);
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
        });
    },

    getUserData() {
      this.loading = !this.loading;
      this.$store
        .dispatch({ type: "getUserDetails" })
        .then(data => {
          this.loading = !this.loading;
          this.$store.commit(types.USERDETAIL, data.data.data);
        })
        .catch(err => {
          this.loading = !this.loading;
          this.$store.commit(types.AUTHORIZED, false);
        });
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  beforeMount() {
    this.changeLocale();
    this.getUserData();
    this.getLatestGoldPrice();
  },

  mounted() {
    try {
      this.interval = setInterval(() => {
        this.getLatestGoldPrice();
      }, 300000);
    } catch (err) {
      toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
    }
    SessionHelper.setCookie("isRedirectToPayment", false);
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/status" && from.fullPath == "/") {
      next(false);
      JSBridgePlugin.gotToHome();
    } else {
      next();
    }
  }
};
</script>
